"use client";

import { useRef } from "react";
import { ArrowUpRight, Play } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
gsap.registerPlugin(useGSAP);
export default function Successcaseshero() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.to(".hero-eyebrow", {
        opacity: 0.72,
        duration: 0.6,
        ease: "power2.out"
      });
      gsap.set(".hero-line", {
        y: 24,
        filter: "blur(10px)"
      });
      gsap.to(".hero-line", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.9,
        stagger: 0.12,
        delay: 0.2,
        ease: "power3.out"
      });
      gsap.set(".hero-card", {
        y: 32,
        filter: "blur(10px)"
      });
      gsap.to(".hero-card", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.8,
        delay: 0.7,
        ease: "power3.out"
      });
      gsap.to(".hero-bokeh", {
        rotate: 3,
        duration: 40,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
        transformOrigin: "center center"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(".hero-eyebrow", {
        opacity: 0.72
      });
      gsap.set([".hero-line", ".hero-card"], {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      });
    });
  }, {
    scope: container
  });
  return;
}